import { useContext, useEffect } from "react";
import React from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormInputFieldCurrency } from "@components-shared/desktop/inputs";
import { LimitCategoryTypes } from "@data-types";
import { LIMITS_CONSTANTS } from "@services/account-settings/MyLimitsConstants";
import { DepositContext } from "@state/context/payment/DepositContext";
import { observer } from "mobx-react";

export default observer(function MonthlyLossLimit(props: {
	type: LimitCategoryTypes;
}) {
	const { getValues, trigger, setValue, watch, getFieldState } =
		useFormContext();

	const { t } = useTranslation("my-limits");

	const limitAmountValue: string = watch("amount");

	const depositStore = useContext(DepositContext);

	const isLossLimitRequired =
		depositStore.depositLimitStore.startLossLimitValue > 0 ||
		Number(limitAmountValue) > LIMITS_CONSTANTS.GAMES_MAX_DEPOSIT;

	const label =
		props.type === LimitCategoryTypes.GAMES
			? "my-limits:MONTHLY_GAMES_LOSS_LABEL"
			: "my-limits:MONTHLY_LOSS_LABEL";

	const placeholder =
		props.type === LimitCategoryTypes.GAMES
			? "my-limits:MONTHLY_GAMES_LOSS_PLACEHOLDER"
			: "my-limits:MONTHLY_LOSS_PLACEHOLDER";

	const validationMessage =
		props.type === LimitCategoryTypes.GAMES
			? "my-limits:GAMES_LOSS_BIGGER_THAN_GAMES_DEPOSIT_MESSAGE"
			: "my-limits:LOSS_BIGGER_THAN_DEPOSIT_MESSAGE";

	useEffect(() => {
		if (props.type == LimitCategoryTypes.SPORTS_BETTING) {
			if (
				!depositStore.depositLimitStore.startLossLimitValue &&
				!getFieldState("lossAmount").isTouched
			) {
				setValue(
					"lossAmount",
					isLossLimitRequired ? Number(limitAmountValue) : null
				);
			}
			trigger(["consentGdpr", "consentGgl", "consentCreditCheck"]);
		}

		if (getValues("lossAmount") != null && getValues("lossAmount") != "") {
			trigger("lossAmount");
		}
	}, [limitAmountValue, depositStore.depositLimitStore.startLossLimitValue]);

	return (
		<div className="form--grid__col col col-sml-12 col-med-12 col-lrg-12 col-xlrg-12 col--ssvga-6 col-hdlow-6 col-xxlrg-6 col-huge-6 col-xxxlrg-6">
			<FormInputFieldCurrency
				label={label}
				name="lossAmount"
				type="number"
				step={".01"}
				className="form__field"
				placeholder={placeholder}
				validate={{
					isValueGreaterThanDeposit: (value: string) =>
						Number(value) <= Number(limitAmountValue) ||
						t(validationMessage),
					isNotNegative: (value: string) =>
						!value ||
						Number(value) > 0 ||
						t("ONE_OR_GREATER", { 0: 0 }),
					isMaxLengthReached: (value: string) =>
						Number(value) <= LIMITS_CONSTANTS.GENERAL_MAX_AMOUNT ||
						t("LIMIT_EXCEEDS_MAX_VALUE"),
				}}
				required={isLossLimitRequired}
			/>
		</div>
	);
});
